var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pending-task-list-item",
      class: { odd: _vm.index % 2 === 1 }
    },
    [
      _c("div", { staticClass: "col type" }, [
        _vm._v(_vm._s(_vm.item.pendingTaskTypeDisplay))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col detail" },
        [_c("detail-list", { attrs: { item: _vm.item } })],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb1227ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb1227ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow-pending/components/pending-task-list-item.vue
// module id = 1689
// module chunks = 0